export default __webpack_public_path__ + "static/media/cscenter_banner.a5417a5c.png";